<template>
  <slide-out
    dock="right"
    :size="sideOutCurrentSize"
    ref="projectSlideout"
    @resize="OnResize"
    :min-size="sideOutMinSize"
    :allow-resize="nested ? false : true"
    :append-to="nested ? '' : '#app'"
    :visible.sync="slideouts.active"
    v-on:close="onSlideoutClosing">
    <template v-slot:header>
      <h3 v-if="isFetching" class="font-weight-bold pa-1" small>
        <v-progress-circular :size="16" width="2" indeterminate class="mr-1"></v-progress-circular>
        Fetching Project ...
      </h3>
      <h3 v-else-if="selected.id" class="font-weight-bold pa-1" small>
        <v-icon left>mdi-pencil-box-outline</v-icon> Update: '{{ selected.description }}'
      </h3>
      <h3 v-else class="font-weight-bold pa-1" small>
        <v-icon left>mdi-plus-box-outline</v-icon> Add Project
      </h3>
      <v-btn @click="closeUpdateSlideout()" icon>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>

    <div>
      <div class="text-center d-flex flex-column" v-if="isFetching">
        <img width="300" src="/img/loading.svg" class="py-5 my-8" style="opacity: 0.54" />
        <p class="font-weight-medium">Loading Project data...</p>
      </div>
      <v-form ref="editProjectForm" v-else class="pa-4" v-model="valid">
        <v-autocomplete
          v-model="selected.contractId"
          :items="contractOptions"
          item-value="id"
          item-text="number"
          placeholder="Select Contract"
          clearable
          dense
          attach
          :rules="[formRules.required]"
          :readonly="!!$route.params.contractId"
          outlined></v-autocomplete>
        <v-text-field
          dense
          outlined
          v-model="selected.description"
          label="Project Description"
          placeholder="Project Description"></v-text-field>
        <v-text-field
          dense
          outlined
          attach
          v-model="selected.responsibleCostCenter"
          label="Responsible Cost Center"
          placeholder="Responsible Cost Center">
        </v-text-field>

        <v-row>
          <v-col>
            <DatePicker
              v-model="selected.startDate"
              :rules="[formRules.required]"
              label="Start Date *"></DatePicker>
          </v-col>
          <v-col>
            <DatePicker
              :minDate="selected.startDate"
              v-model="selected.finishDate"
              :rules="[formRules.required]"
              label="Finish Date *"></DatePicker>
          </v-col>
        </v-row>

        <v-text-field
          class="my-3"
          dense
          outlined
          v-model="selected.budget"
          label="Budget"
          placeholder="Budget"></v-text-field>

        <UserSelector
          label="Project Manager *"
          placeholder="Project Manager"
          :rules="[formRules.required]"
          v-model="selected.projectManagerId"></UserSelector>
        <v-text-field
          dense
          outlined
          v-model="selected.wbsElementId"
          type="number"
          label="WBS Element ID"
          placeholder="WBS Element ID"></v-text-field>
        <v-text-field
          dense
          outlined
          v-model="selected.wbsElementDescription"
          label="WBS Element Description"
          placeholder="WBS Element Description"></v-text-field>

        <v-row>
          <v-col>
            <DatePicker
              v-model="selected.scheduledStartDate"
              label="Scheduled Start Date"></DatePicker>
          </v-col>
          <v-col>
            <DatePicker
              :minDate="selected.scheduledStartDate"
              v-model="selected.scheduledFinishDate"
              label="Scheduled End Date"></DatePicker>
          </v-col>
        </v-row>
        <v-text-field
          class="my-3"
          dense
          outlined
          v-model="selected.estimatedCosts"
          label="Estimated Costs"
          placeholder="Estimated Costs"></v-text-field>
        <v-textarea
          dense
          outlined
          v-model="selected.milestones"
          label="Milestones"
          placeholder="List key milestones for the project."></v-textarea>
        <v-textarea
          dense
          outlined
          v-model="selected.dependencies"
          label="Dependencies"
          placeholder="Describe any dependencies or constraints affecting the project."></v-textarea>
        <v-textarea
          dense
          outlined
          v-model="selected.requirements"
          label="Resource Requirements"
          placeholder="Specify the resources needed for the project, including personnel, equipment, and materials."></v-textarea>
      </v-form>
    </div>
    <template v-slot:footer>
      <v-card-actions>
        <v-btn text color="error" @click="closeUpdateSlideout()">
          <v-icon left>mdi-chevron-left</v-icon> Close
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          :disabled="!valid || slideouts.isLoading || !slideouts.hasChanges || !canSaveChanges"
          @click="updateConfirmed()"
          :loading="slideouts.isLoading">
          <v-icon left>{{ selected.id ? 'mdi-check' : 'mdi-plus' }}</v-icon>
          {{ selected.id ? 'Save Changes' : 'Create' }}
        </v-btn>
      </v-card-actions>
    </template>
  </slide-out>
</template>

<script>
  import UserSelector from '@Share/components/UserSelector.vue';
  import formRules from '@Share/config/form-rules';
  import DatePicker from '@Share/components/VDatePicker';
  import { $handleError, $isEqual, $formatDate } from '@Utils';
  import dayjs from 'dayjs';
import permissions from '@/features/Share/config/permissions';
import { $has } from '@/utils';

  export default {
    name: 'edit-Project',
    data() {
      return {
        valid: false,
        formRules,
        isFetching: false,
        selected: {},
        modal: false,
        modal2: false,
        modal3: false,
        modal4: false,
        selectedCemented: {},
        slideouts: {
          tab: 0,
          active: false,
          isLoading: false,
          isClosing: false,
          hasChanges: false,
        },
        timerId: null,
      };
    },
    props: {
      nested: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      canSaveChanges(){
        if(this.selected.id){
         return $has(permissions.TaskBoardProjects.Update);
        }
        return  $has(permissions.TaskBoardProjects.Create);
      
      },
      contractOptions() {
        return this.$store.getters['CONTRACT/GET_ENTRIES'];
      },
      sideOutMinSize: {
        get() {
          return this.$store.getters['GET_SIDOUT_MINSIZE'];
        },
        set(val) {
          this.$store.commit('SET_SIDOUT_MINSIZE', val);
        },
      },
      sideOutCurrentSize: {
        get() {
          return this.$store.getters['GET_SIDOUT_CURRENTSIZE'];
        },
        set(val) {
          this.$store.commit('SET_SIDOUT_CURRENTSIZE', val);
        },
      },
    },
    methods: {
      OnResize() {
        let projectSlideout = this.$refs.projectSlideout;
        this.sideOutCurrentSize = projectSlideout.resizeValue;
      },
      allowedDates(val) {
        return this.selected.startDate ? dayjs(val).isAfter(this.selected.startDate) : true;
      },
      allowedDatesScheduled(val) {
        return this.selected.scheduledStartDate
          ? dayjs(val).isAfter(this.selected.scheduledStartDate)
          : true;
      },

      onSlideoutClosing() {
        this.$emit('close');
        this.closeUpdateSlideout();
      },
      updateConfirmed() {
        this.slideouts.isLoading = true;
        let toSend = structuredClone(this.selected);
        
        this.$store
          .dispatch('PROJECT/UPDATE', toSend)
          .then((res) => {
            this.$emit('onProjectUpdate',res);
            this.closeUpdateSlideout();
          })
          .catch((err) => {
            $handleError(err);
          })
          .finally(() => {
            this.slideouts.isLoading = false;
          });
      },
      closeUpdateSlideout() {
        this.selected = {};
        this.isFetching = false;
        this.cementProject();
        this.slideouts.active = false;
        this.valid = true;
        this.$refs.editProjectForm.resetValidation();
      },
      open(id) {
        if (id != null) {
          this.ProjectId = id;
          this.fetchProject();
        }else{
          this.selected.contractId=   this.$route.params.contractId;
        }
        this.slideouts.active = true;
      },
      $formatDate,
      fetchProject() {
        this.isFetching = true;
        this.$store
          .dispatch('PROJECT/GET_BY_ID', this.ProjectId)
          .then((resp) => {
            this.isFetching = false;
            this.slideouts.isLoading = false;
            const data = structuredClone(resp.data);
            data.startDate = $formatDate(data.startDate, 'YYYY-MM-DD');
            data.finishDate = $formatDate(data.finishDate, 'YYYY-MM-DD');
            data.scheduledFinishDate = $formatDate(data.scheduledFinishDate, 'YYYY-MM-DD');
            data.scheduledStartDate = $formatDate(data.scheduledStartDate, 'YYYY-MM-DD');
            this.selected = data;
            this.cementProject();
          })
          .catch((err) => {
            this.isFetching = false;
            this.closeUpdateSlideout();
            $handleError(err);
          });
      },
      cementProject() {
        this.selectedCemented = structuredClone(this.selected);
        this.checkForChanges();
      },
      checkForChanges() {
        if (!this.slideouts.active) return;
        this.slideouts.hasChanges = !$isEqual(this.selected, this.selectedCemented);
        
      },
      getContractDataDebounced() {
        if (this.timerId == null) {
          this.timerId = -1;
          this.$store.dispatch('CONTRACT/GET');
          return;
        }
        // cancel pending call
        clearTimeout(this.timerId);

        // delay new call 400ms
        this.timerId = setTimeout(() => {
          this.$store.dispatch('CONTRACT/GET');
        }, 400);
      },
    },
    watch: {
      selected: {
        handler() {
          this.checkForChanges();
        },
        deep: true,
      },
      nested: {
        handler() {
          this.nested ? (this.sideOutCurrentSize = '80vw') : (this.sideOutCurrentSize = '35vw');
          this.nested ? (this.sideOutMinSize = '80vw') : (this.sideOutMinSize = '35vw');
        },
        deep: true,
      },
    },
    components: {
      UserSelector,
      DatePicker,
    },
    created() {
      this.getContractDataDebounced();
     
    },
  };
</script>
